import { DirectUploadMedia } from "libs/directUpload";
import * as yup from "yup";

import { ProductsListItem } from "../../../products";

export const productSetValidationSchema = yup.object({
  coverMedia: yup
    .mixed<DirectUploadMedia>()
    .nullable()
    .defined()
    .test(
      "is-present",
      "Banner is required",
      (value) => value !== null && value !== undefined
    ),
  title: yup
    .string()
    .notRequired()
    .nullable()
    .transform((v) => (v === "" ? null : v)),
  description: yup
    .string()
    .max(250, "Description must be less than 250 characters")
    .notRequired()
    .nullable()
    .transform((v) => (v === "" ? null : v)),
  showOnHome: yup.boolean().required("Show on Home is required"),
  showInSearch: yup.boolean().required("Show in Search is required"),
  allowCoverMediaDisplayInFullScreenMode: yup
    .boolean()
    .notRequired()
    .default(true),
  productVariants: yup.array<ProductsListItem[]>(yup.object()).required()
});
